import { useQuery } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

import { axios } from "@/client/libs/axios";
import { queryKeys } from "@/client/queries/keys";

export type MeSettings = {
  density: string;
  theme: string;
  sidebarCollapsed: boolean;
};

export type MeData = {
  id: string;
  name: string;
  email: string;
  username: string;
  picture?: string | null;
  locale: string;
  settings: MeSettings;
  onboardingCompleted: boolean;
  onboardingStep?: string | null;
  subscription?: {
    // Canonical post-Lemon-Squeezy field. Older code (and the seed
    // fixtures) still read `.plan`; keep it optional so both work.
    tier?: "FREE" | "PRO" | "ULTIMATE";
    plan?: string;
    lsSubscriptionId?: number | null;
    lsCurrentPeriodEnd?: string | null;
    status?: "ACTIVE" | "CANCELED" | "PAST_DUE" | "TRIALING" | "INCOMPLETE";
  } | null;
  // Additional fields from UserDto passed through but not strictly typed here
};

const fetchMe = async (): Promise<MeData> => {
  const response = await axios.get<MeData, AxiosResponse<MeData>>("/user/me");
  return response.data;
};

/**
 * Query hook returning the current user including 024 fields:
 * settings, onboardingCompleted, onboardingStep.
 */
export const useMe = () => {
  return useQuery({
    queryKey: queryKeys.me.detail(),
    queryFn: fetchMe,
  });
};
